module.exports = __webpack_public_path__ + "staticfr/media/more-white.10b8350f.svg";